const defaultState: any = null;

const userPlanReducer = (state = defaultState, action: { type: string; payload: any }) => {
	switch (action.type) {
		case 'SET_USER_PLAN':
			return action.payload;

		default:
			return state;
	}
};

export default userPlanReducer;
